import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { SocialNetworkIcon } from 'components';
import { FlyoutSection } from 'containers';
import Checkbox from 'material-ui/Checkbox';
import styles from './FilterPanel.scss';
var FilterPanel = (_dec = connect(function (state) {
  return {
    theme: state.theme,
    organization: state.organization.current
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(FilterPanel, _Component);

  var _super = _createSuper(FilterPanel);

  function FilterPanel() {
    _classCallCheck(this, FilterPanel);

    return _super.apply(this, arguments);
  }

  _createClass(FilterPanel, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement("div", {
        className: styles.filters
      }, /*#__PURE__*/React.createElement(FlyoutSection, {
        title: "FILTER"
      }, this.props.filters.map(function (filter, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: filter.key,
          className: styles.filter
        }, /*#__PURE__*/React.createElement(Checkbox, {
          label: /*#__PURE__*/React.createElement("span", {
            className: styles.filterLabel
          }, filter.icon ? filter.icon() : null, " ", filter.name),
          style: {
            marginLeft: '15px'
          },
          checked: filter.selected,
          onCheck: function onCheck(e, isChecked) {
            if (_this.props.onChange) {
              _this.props.onChange(filter.key, isChecked);
            }
          }
        }));
      })));
    }
  }]);

  return FilterPanel;
}(Component), _defineProperty(_class2, "defaultProps", {
  filters: []
}), _temp)) || _class);
export { FilterPanel as default };